export default "__VITE_ASSET__CTPXZ_8P__"